import common from "./common.json";

export const id = {
  common,
};
